import { useState, useEffect, useCallback } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { AppShell } from './components/AppShell'
import { ConnectDialog } from './components/ConnectDialog'
import { OrgsPage } from './components/OrgsPage'
import { OrgDetailPage } from './components/OrgDetailPage'
import { RdDetailPage } from './components/RdDetailPage'
import { PolicyMatrixPage } from './components/PolicyMatrixPage'
import { AgentsPage } from './components/AgentsPage'
import { AuditLogPage } from './components/AuditLogPage'
import { RdAdminHome } from './components/RdAdminHome'
import { CheckTesterPage } from './components/CheckTesterPage'
import { SettingDefsPage } from './components/SettingDefsPage'
import { ResourceTypesPage } from './components/ResourceTypesPage'
import { getHealth } from './services/authApi'
import { PersonaProvider, usePersona } from './PersonaContext'

export function App() {
  const [connected, setConnected] = useState(false)
  const [checking, setChecking] = useState(true)

  const checkConnection = useCallback(async () => {
    const key = localStorage.getItem('authServiceKey')
    const url = localStorage.getItem('authServiceUrl')
    if (!key || !url) {
      setChecking(false)
      return
    }
    try {
      await getHealth()
      setConnected(true)
    } catch {
      // Key or URL invalid
    }
    setChecking(false)
  }, [])

  useEffect(() => { checkConnection() }, [checkConnection])

  if (checking) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        Connecting...
      </Box>
    )
  }

  if (!connected) {
    return <ConnectDialog onConnect={() => setConnected(true)} />
  }

  return (
    <PersonaProvider>
      <AppShell>
        <AppRoutes />
      </AppShell>
    </PersonaProvider>
  )
}

// Routes are persona-aware: in RD-Admin preview, the home/org routes redirect to
// the RD-Admin landing (pick-an-RD), and the platform-only screens are blocked.
function AppRoutes() {
  const { canPlatform } = usePersona()
  return (
    <Routes>
      <Route path="/" element={<Navigate to={canPlatform ? '/orgs' : '/rd-home'} replace />} />
      <Route path="/rd-home" element={<RdAdminHome />} />
      <Route path="/orgs" element={canPlatform ? <OrgsPage /> : <Navigate to="/rd-home" replace />} />
      <Route path="/orgs/:orgId" element={canPlatform ? <OrgDetailPage /> : <Navigate to="/rd-home" replace />} />
      <Route path="/rds/:rdId" element={<RdDetailPage />} />
      <Route path="/rds/:rdId/policies" element={<PolicyMatrixPage />} />
      <Route path="/rds/:rdId/agents" element={<AgentsPage />} />
      <Route path="/rds/:rdId/audit" element={<AuditLogPage />} />
      <Route path="/check" element={<CheckTesterPage />} />
      <Route path="/settings" element={canPlatform ? <SettingDefsPage /> : <Navigate to="/rd-home" replace />} />
      <Route path="/resource-types" element={canPlatform ? <ResourceTypesPage /> : <Navigate to="/rd-home" replace />} />
    </Routes>
  )
}
